import { ATT } from './ATT';
import { ATTDTV } from './ATTDTV';
import { Astound } from './Astound';
import { Brightspeed } from './Brightspeed';
import { BrightspeedV2 } from './BrightspeedV2';
import { BuckeyeBroadband } from './BuckeyeBroadband';
import { CenturyLink } from './CenturyLink';
import { CincinnatiBell } from './CincinnatiBell';
import { Comcast } from './Comcast';
import { Cox } from './Cox';
import { DTV } from './DTV';
import { Dish } from './Dish';
import { MyDish } from './MyDish';
import { Earthlink } from './Earthlink';
import { FidiumFiber } from './FidiumFiber';
import { Frontier } from './Frontier';
import { GoogleFiber } from './GoogleFiber';
import { Grande } from './Grande';
import { Mediacom } from './Mediacom';
import { MiFiber } from './MiFiber';
import { NexGen } from './NexGen';
import { Optimum } from './Optimum';
import { RCN } from './RCN';
import { Spectrum } from './Spectrum';
import { Starlink } from './Starlink';
import { Starry } from './Starry';
import { TDS } from './TDS';
import { Verizon } from './Verizon';
import { VerizonFWA } from './VerizonFWA';
import { WOW } from './WOW';
import { Wave } from './Wave';
import { QuantumFiber } from './QuantumFiber';
import { Windstream } from './Windstream';

// NOTES:
// 1. we do not include DTV nor ATTDTV in the main provider config list yet.
// 2. BrightSpeedV2 is included instead of BrightSpeed.
export const ProviderConfigList = [
  Astound,
  ATT,
  BrightspeedV2,
  BuckeyeBroadband,
  CenturyLink,
  CincinnatiBell,
  Comcast,
  Cox,
  Earthlink,
  FidiumFiber,
  Frontier,
  GoogleFiber,
  Grande,
  Mediacom,
  MiFiber,
  Optimum,
  NexGen,
  RCN,
  Spectrum,
  Starlink,
  Starry,
  TDS,
  Verizon,
  VerizonFWA,
  WOW,
  Wave,
  QuantumFiber,
  Windstream,
];

export * from './Astound';
export * from './ATT';
export * from './ATTDTV';
export * from './Brightspeed';
export * from './BrightspeedV2';
export * from './BuckeyeBroadband';
export * from './CenturyLink';
export * from './CincinnatiBell';
export * from './Comcast';
export * from './Cox';
export * from './DTV';
export * from './Dish';
export * from './MyDish';
export * from './Earthlink';
export * from './FidiumFiber';
export * from './Frontier';
export * from './GoogleFiber';
export * from './Grande';
export * from './Mediacom';
export * from './MiFiber';
export * from './NexGen';
export * from './Optimum';
export * from './RCN';
export * from './Spectrum';
export * from './Starlink';
export * from './Starry';
export * from './TDS';
export * from './Verizon';
export * from './VerizonFWA';
export * from './WOW';
export * from './QuantumFiber';
export * from './Wave';
export * from './Windstream';

export * from './helpers';
